import { NavigateFunction } from 'react-router-dom';
import { ROUTES } from 'navigation/constants';
import { getOnboardingConfig } from 'features/Task/utils/getOnboardingConfig';

/**
 * Handles click on lesson cards, with special handling for onboarding lesson
 * @param navigate - React Router navigation function
 * @param lessonId - The ID of the clicked lesson
 */
export function handleOnboardingClick(navigate: NavigateFunction, lessonId: string, lessonType?: string): void {
  if (lessonType === 'onboarding') {
    // Get onboarding task configuration from Statsig
    const { taskId, taskName } = getOnboardingConfig();
    
    // If no taskId is configured, fall back to regular lesson flow
    if (!taskId) {
      navigate(ROUTES.LESSON.buildPath({ id: lessonId }));
      return;
    }
    
    // Navigate directly to task/chat, using the onboarding task ID
    navigate(
      ROUTES.TASK.buildPath({
        id: taskId,
      }),
      {
        state: {
          lessonId,
          skipTaskSelection: true,
          taskName: taskName || 'Getting to Know You',
          taskType: 'onboarding',
        },
      }
    );
  } else {
    // Regular lesson flow
    navigate(ROUTES.LESSON.buildPath({ id: lessonId }));
  }
}